
export default class EsEnum {
  constructor(arr) {
    const nameArr = []
    const valueArr = []
    if (!Array.isArray(arr)) {
      throw Error('arr is not an array!')
    }

    arr.forEach(element => {
      if (!element.name || (Number.isNaN(element.value) && !element.value)) {
        return
      }
      // 保存key值组成的数组，方便A.getName(value)类型的调用
      nameArr.push(element.name)
      valueArr.push(element.value)
      // 根据key生成不同属性值，以便A.B.value类型的调用
      this[element.name] = element
    })

    // 保存源数组
    this.arr = arr
    this.nameArr = nameArr
    this.valueArr = valueArr
  }

  /**
     * 根据key得到对象
     * @param {*} name
     */
  nameOf(name) {
    return this.arr[this.nameArr.indexOf(name)]
  }

  /**
     * 根据key得到对象
     * @param {*} name
     */
  valueOf(value) {
    return this.arr[this.valueArr.indexOf(value)]
  }
  /**
     * 根据key获取value值
     * @param {*} name
     */
  getValueByKey(name) {
    const prop = this.nameOf(name)
    if (!prop) {
      throw Error(`No enum constant${name}`)
    }
    return prop.value
  }

  /**
     * 根据value获取name值
     * @param {*} name
     */
  getNameByValue(value) {
    const prop = this.valueOf(value)
    if (!prop) {
      throw Error(`No enum constant${value}`)
    }
    return prop.name
  }
  /**
     * 返回源数组
     */
  getValues() {
    return this.arr
  }
  /**
     * 返回源数组
     */
  getNames() {
    return this.nameArr
  }
}

// 使用方式
// const ResourceStatusEnum = new EsEnum([
//     { name: '未审核', value: 0 },
//     { name: '启用', value: 1 },
//     { name: '审核未通过', value: 2 },
//     { name: '停用', value: 3 },
// ]);

// console.log(ResourceStatusEnum.未审核.value);
// console.log(ResourceStatusEnum.valueOf('启用'));
// console.log(ResourceStatusEnum.getCodeByKey('启用'));
// console.log(ResourceStatusEnum.getValues());
